import { ApiBase } from './api-base';

/**
 * @template R
 * @typedef {import('axios').AxiosResponse<R>} AxiosResponse<R>
 */
/**
 * @typedef {import('../types/location.api.types').Location} Location
 */

export class LocationsApi extends ApiBase {
  /** @returns {Promise<AxiosResponse<Location[]>>} */
  getLocations = () => this.apiClient.sendRequest({
    method: 'GET',
    url: 'locations/',
  });
}
